<template>
  <div class="wrap">
    <header style=" display: flex;justify-content: center;">
      <span style="position: absolute;left: 20px;" class="iconfont icon-back-left" @click="goBack"></span>
      <h2 style="    width: 100%;">{{ lang.addCrypto }}</h2>
    </header>
    <div class="main">
      <p class="title">{{ lang.add }} {{type}} {{lang.address}}</p>
      <p class="navbar">
        <span :class="{'active':type=='ERC20'}" @click="choseType('ERC20')">ERC20</span>
        <span :class="{'active':type=='TRC20'}" @click="choseType('TRC20')">TRC20</span>
      </p>
      <p class="item">
        <input type="text" :placeholder="lang.enterCrypto" v-model="addr">
      </p>
      <div class="tips">{{ lang.tipCrypto }}</div>
      <div class="next-btn" @click="submit">{{lang.confirm}}</div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {
    mapState
  } from 'vuex'
  import router from "../../router";
  export default {
    data() {
      return {
        type:"ERC20",
        addr:'',
        currency:['ERC20','TRC20'],
        bindInfo:{},
      }
    },
    computed: {
      ...mapState(['lang', 'userInfo'])
    },
    created() {
      this.getData()
    },
    methods: {
      goBack() {
        router.go(-1)
      },
      choseType(item){
        this.type = item;
        this.addr = this.bindInfo[item];
      },
      submit() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/member/bindCCy',{
          type:this.type,
          addr:this.addr
        })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.$toast({
                message: "",
                iconClass: 'iconfont icon-chenggong',
                duration: 2000
              })
              setTimeout(()=>{
                this.$router.push('Payment')
              },2000)
            } else if (res.data.err == 102) {
              this.$router.push('Login');
              localStorage.setItem('tk', res.data.tk);
              router.push("login")
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
      getData() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/member/bindInfo',{}).then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.bindInfo = res.data.data
            } else if (res.data.err == 102 || res.data.err == 106) {
              this.$router.push('Login');
              localStorage.setItem('tk', res.data.tk);
              router.push("login")
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      }
    }
  }
</script>
<style type="text/css"  scoped>
  .title {
    margin-top: 20px;
    padding-left: 20px;
    color: #333;
    font-size: 16px;
    font-weight: bold;
  }

  .item {
    margin: 12px 20px;
    padding: 0 12px;
    height: 50px;
    border-radius: 6px;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    color: #666;
  }
  .item input{
    width:100%;
    height: 100%;
    background: none;
  }
  .navbar{
    display: flex;
    padding:20px;
    align-items: center;
  }
  .navbar span{
    padding:5px 10px;
    color:#333;
    margin-right:12px;
  }
  .navbar span.active{
    border-radius: 5px;
    border:1px solid #3476FE;
  }

  .tips{
    padding:20px;
    color:#999;
  }

  .next-btn {
    margin: 30px 30px 0;
    background: #3476FE;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: 30px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
  }
</style>